module.exports = __webpack_public_path__ + "media/components/country-flag/static/mv-e36a8f8c3ba968fde9955100daaa73d1.svg";